<template>
  <div ref="containerRef" class="advantages-segment -mt-6 bg-red-gradient rounded-t-3xl flex flex-col md:flex-row pt-6 md:pt-0 items-center gap-6">
    <div class="mt-8 md:mt-32 md:p-8 w-full max-h-[calc(100vh-200px)] flex flex-col items-center justify-center">
      <iframe
        class="grow w-full aspect-video"
        src="https://www.youtube.com/embed/ID0oRmzTuaw?rel=0"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

const containerRef = ref()
const { t } = useI18n()

const scroll = () => {
  containerRef.value.scrollIntoView({ behavior: 'smooth' })
}

defineExpose({ scroll })
</script>
